
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAnalog50 as ObiTwowayAnalog50Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-analog-50.js';
 
 
 

 
 export const ObiTwowayAnalog50 = createComponent({
   react: React,
   tagName: 'obi-twoway-analog-50',
   elementClass: ObiTwowayAnalog50Element,
   events: {
     
   }
  });
 
 